// extracted by mini-css-extract-plugin
module.exports = {"Container":"ResultsHeader_Container__2XnQJ","Search":"ResultsHeader_Search__1Tfy6","Button":"ResultsHeader_Button__2vbVD","Clear":"ResultsHeader_Clear__2rqN4"};